module.exports = __webpack_public_path__ + "img/window-minimize.2a4a19c1.svg";